import { Field, InputType } from 'type-graphql'
import type { IAction } from '../../action/IAction'
import { ActionArgs } from '../../action/ActionArgs'
import type { MatchedDocument } from '../MatchedDocument'

@InputType()
export class FindDocumentByCodeArgs extends ActionArgs {
  @Field(() => [String])
  codes: string[]
}

export interface IFindDocumentByCode extends IAction<MatchedDocument[], FindDocumentByCodeArgs> {}
